export default "__VITE_ASSET__BLBnX$I9__"